// extracted by mini-css-extract-plugin
module.exports = {"bg-overlay":"_1eCSh","bgOverlay":"_1eCSh","bg-img-overlay":"_37Ao-","bgImgOverlay":"_37Ao-"};